import React from 'react';
import {MINI_DRAWER} from "constants/ActionTypes";
import TopLogo from '../../assets/logoTop.png'; 
import LogoMini from '../../assets/LogoMini.png'; 
import LogoTop2 from '../../assets/LogoTop2.png'; 


const SidenavLogo = ({drawerType}) => {

    const showMini = drawerType.includes(MINI_DRAWER);

    return (
        <div className="sidebar-header d-flex align-items-center">
            {showMini ?
                <div className="mini-logo">
                    <img className="mini-logo-img" alt='...' src={LogoMini}/>
                    <img className="mini-logo-img-hover" alt='...' src={LogoTop2}/>
                </div> : <img alt='...' src={TopLogo} />
            }
        </div>
    );
};

export default SidenavLogo;



// WEBPACK FOOTER //
// ./components/SidenavLogo/index.js